export interface ApiChatMessage {
  role: 'user' | 'assistant';
  content: string;
}

export async function postChat(
  history: ApiChatMessage[],
  currentPatientId: string | null,
): Promise<string> {
  const res = await fetch('/api/chat', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ messages: history, currentPatientId }),
  });

  if (!res.ok) {
    const fallback = `HTTP ${res.status}`;
    const err = await res
      .json()
      .then((j: { error?: string }) => j.error ?? fallback)
      .catch(() => fallback);
    throw new Error(err);
  }

  const data = (await res.json()) as { content?: string };
  if (!data.content) {
    throw new Error('Respuesta vacía del servidor');
  }
  return data.content;
}
